import Checkbox from '@material-ui/core/Checkbox';
import { withStyles } from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Tooltip from '@material-ui/core/Tooltip';
import PropTypes from 'prop-types';
import React from 'react';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';

import { tablecellStyles } from './styles';

const rows = [
    { id: '', numeric: false, disablePadding: false, label: '' },
    { id: 'customerName', numeric: false, disablePadding: false, label: 'voucher_listcustomer_tablehead_customer_name' },
    { id: 'customerMobile', numeric: false, disablePadding: false, label: 'voucher_listcustomer_tablehead_mobile' },
    { id: 'customerGender', numeric: false, disablePadding: false, label: 'voucher_listcustomer_tablehead_gender' },
    { id: 'customerDistrict', numeric: false, disablePadding: false, label: 'voucher_listcustomer_tablehead_district' },
    { id: 'customerCity', numeric: false, disablePadding: false, label: 'voucher_listcustomer_tablehead_city' },
];


class EnhancedTableHead extends React.Component {
    createSortHandler = property => event => {
        this.props.onRequestSort(event, property);
    };

    render() { 
        const { onSelectAllClick, order, orderBy, numSelected, rowCount } = this.props;
        const { classes,t } = this.props;

        return (
            <TableHead>
                <TableRow>
                    <TableCell padding="checkbox" classes={{ head: classes.smallWidth }}>
                        <Checkbox
                            indeterminate={numSelected > 0 && numSelected < rowCount}
                            checked={numSelected === rowCount}
                            onChange={onSelectAllClick}
                            color="primary" 
                        />
                    </TableCell>
                    {rows.map(row => {
                        return (
                            <TableCell
                                classes={{
                                    head: (row.id === 'quatity') ? classes.alignCenter : classes.normal
                                }}
                                key={row.id} 
                                padding={row.disablePadding ? 'none' : 'dense'}
                                sortDirection={orderBy === row.id ? order : false}
                            >
                                <Tooltip
                                    title="Sort"
                                    placement={row.numeric ? 'bottom-end' : 'bottom-start'}
                                    enterDelay={300}
                                >
                                    <TableSortLabel
                                        active={orderBy === row.id}
                                        direction={order}
                                        onClick={this.createSortHandler(row.id)}
                                    >
                                        {t(row.label)}
                                    </TableSortLabel>
                                </Tooltip>
                            </TableCell>
                        );
                    }, this)}
                </TableRow>
            </TableHead >
        );
    }
}

EnhancedTableHead.propTypes = {
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.string.isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
};

const mapState = state => ({ 
});

const mapDispatch = dispatch => ({ 
});

export default connect(mapState, mapDispatch)(translate('translations')(withStyles(tablecellStyles)(EnhancedTableHead)));
